// "use client";

// import { SourceBytesProvider, SourceBytesWidget } from "sourcebytes_bot_sdk";
// import "sourcebytes_bot_sdk/dist/styles.css";
// import { API_URL } from "../../server";

// export default function BotIntegration({ botId, userId }) {

//   const useremail = sessionStorage.getItem("email");

//   const options = {
//     botId: botId,
//     userId: useremail,
//     apiUrl: "https://app.sourcebytes.ai/api/v1/",
//     onBeforeSendMessage: async ({ userId, message }) => {
//       const res = await fetch(API_URL + "userMessageUsage", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ userId, message }),
//       });

//       if (!res.ok) throw new Error("Usage check failed");

//       const data = await res.json();
//       console.log('hhhhhhhhhhhhhhhhhh', data)
//       // returning messagesLeft from api is mandatory for sdk validation
//       return {
//         messagesLeft: data.messagesLeft,
//         // userMetadata: data.userMetadata,
//       };
//     },
//     onMessageLimitReached: () => {
//       console.warn("Message limit reached");
//     },
//     configOverrides: {
//       widget_shape: "round",
//       action_color: "#E91E63",
//     },

//     avatar: {
//       image: "https://image/media/avatar.svg",
//     },
//   };

//   return (
//     <SourceBytesProvider options={options}>
//       <SourceBytesWidget />
//     </SourceBytesProvider>
//   );
// }

"use client";

import { useEffect } from "react";
import {
  SourceBytesProvider,
  SourceBytesWidget,
  useSourceBytes,
} from "sourcebytes_bot_sdk";
import "sourcebytes_bot_sdk/dist/styles.css";
import { API_URL } from "../../server";

/* Auto-open helper */
function AutoOpenChat() {
  const { toggleWidget } = useSourceBytes();

  useEffect(() => {
    toggleWidget(); // ✅ opens chat immediately
  }, []);

  return null;
}

export default function BotIntegration({ botId, userId }) {
  const useremail = sessionStorage.getItem("email");

  const options = {
    botId: botId,
    userId: useremail,
    apiUrl: "https://app.sourcebytes.ai/api/v1/",

    /* ✅ REQUIRED FLAGS */
    showChatLaunchButton: false,
    welcomeScreen: false,

    onBeforeSendMessage: async ({ userId, message }) => {
      const res = await fetch(API_URL + "userMessageUsage", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, message }),
      });

      if (!res.ok) throw new Error("Usage check failed");

      const data = await res.json();
      return {
        messagesLeft: data.messagesLeft,
      };
    },

    onMessageLimitReached: () => {
      console.warn("Message limit reached");
    },

    configOverrides: {
      widget_shape: "round",
      // action_color: "#FF6B47",
    },

    avatar: {
      image: "https://image/media/avatar.svg",
    },
  };

  return (
    <SourceBytesProvider
      options={options}
      showChatLaunchButton={false} // ✅ enforce at provider level
      welcomeScreen={false} // ✅ enforce at provider level
    >
      <AutoOpenChat />
      <SourceBytesWidget  />
    </SourceBytesProvider>
  );
}
